<li *ngIf="userService.isEmployee() " class="nav-item dropdown dropdown-user-profile-settings control-anim">
  <a (click)="showDropdown($event)" class="dropdown-toggle dropdown-toggle-no-arrow nav-link" href="#"
    id="dropdownMainMenuPS" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i
      class="pj-ico pj-ico-120 pj-ico-ajustes"></i></a>
  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMainMenuPS" id="divDropdownMainMenuPS"
    [class.height-fit]="isLoadingSearch">



    <div class="alert-icon-text d-flex justify-content-center mgn-bottom-25 text-center">
      <div class="inner-section">
        <i class="pj-ico pj-ico-ampolleta text-primary"></i>
      </div>
      <div class="inner-section">
        <p class="no-mgn">¡Mantén tu perfil <strong>constantemente<br>actualizado para los
            reclutadores</strong>!</p>
      </div>
    </div>
    <div class="loading-ctn" *ngIf="isLoadingSearch">
      <app-loading-table></app-loading-table>
    </div>

    <div [class.d-none]="isLoadingSearch">

      <div class="account-stats mgn-bottom-10">
        <div class="inner-section">
          <div class="single-stat-group">
            <div class="single-stat">
              <span class="stat-name">Postulaciones enviadas</span>
              <div class="stat-counter">{{profileConfig?.applications}}</div>
            </div>
            <div class="single-stat">
              <span class="stat-name">Visitas<br>a tu perfil</span>
              <div class="stat-counter">{{profileConfig?.views}}</div>
            </div>
          </div>
        </div>
        <div class="inner-section">
          <div class="account-fill-progress">
            <div class="progress-text" data-placement="bottom" data-trigger="focus" data-html="true"
              [attr.data-content]="datacontentpopover" tabindex="0">Tu perfil está&nbsp;
              <div class="percentage-ctn" [ngClass]="{ 
              '': 25 >= profileConfig?.profileCompleted ,
              'fill-26-50': 50 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted > 25,
              'fill-51-75': 75 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted >  51,
              'fill-76-100': 100 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted >   76
              }">
                <span class="percentage-num statsAnim "
                  data-end-val="{{profileConfig?.profileCompleted}}">{{employeeProfileCompletedAnim}}</span>%
              </div>
              &nbsp;completo
            </div>
            <div class="progress-bar-ctn">
              <div [ngClass]="{ 
              '': 25 >= profileConfig?.profileCompleted ,
              'fill-26-50': 50 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted > 25,
              'fill-51-75': 75 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted >  51,
              'fill-76-100': 100 >= profileConfig?.profileCompleted && profileConfig?.profileCompleted >   76
              }" class="custom-progress-bar statsAnim" data-end-val="{{profileConfig?.profileCompleted}}"
                [ngStyle]="{width:employeeProfileCompletedAnim+'%'}" role="progressbar"></div>
            </div>
            <a (click)="sendActionFormUpdate('lowestlevel')" role="button" class="font-size-13 font-weight-bold"
              target="_self">{{employeeProfileCompletedAnim===100?'Editar':'Mejorar'}} mi perfil</a>
          </div>
        </div>

      </div>
      <div class="text-center">
        <span class="badge badge-info-2 no-mgn"><i class="extra-info-icon pj-ico pj-ico-usuarios-editar"></i>Última
          edición de perfil:
          {{profileConfig?.dateEdition | date:'dd/MM/yyyy'}}</span>
      </div>
      <hr />
      <form [formGroup]="_formGroup">
        <div class="setting-group">
          <div class="setting">
            <h5 class="setting-title">
              Notificaciones </h5>
            <div class="setting-ctn">
              <div class="setting-section">
                <div class="alert-icon-text d-flex">
                  <div class="inner-section">
                    <i class="pj-ico pj-ico-info text-primary"></i>
                  </div>
                  <div class="inner-section">
                    <p class="no-mgn">Te llegarán <strong>emails con nuevas oportunidades</strong></p>
                  </div>
                </div>
              </div>
              <div class="setting-section setting-section-control">
                <label for="user-setting-control-1" class="accesibleHidden">Frecuencia de las
                  notificaciones</label>
                <select id="user-setting-control-1" class="form-control" formControlName="employeeNotification">
                  <option value="O0">Apagadas</option>
                  <option value="O1">Diarias</option>
                  <option value="O2">Semanales</option>
                </select>
              </div>
            </div>
          </div>
          <div class="setting">
            <h5 class="setting-title">Intereses declarados</h5>
            <div class="setting-ctn">
              <div class="setting-section">
                <div class="alert-icon-text d-flex">
                  <div class="inner-section">
                    <i class="pj-ico pj-ico-info text-primary"></i>
                  </div>
                  <div class="inner-section">
                    <p class="no-mgn"><strong>Guarda Preferencias</strong> y determina qué oportunidades te
                      llegan al correo</p>
                  </div>
                </div>
              </div>
              <div class="setting-section setting-section-control">
                <div>
                  <div class="switch-label" data-toggle="popover" data-placement="top" data-trigger="focus"
                    data-html="true"
                    data-content="Configura estas preferencias en la página &#34;Explorar anuncios&#34;" tabindex="0">
                    <label class="switch">
                      <input [attr.checked]="profileConfig?.preferences === 1 ? '' : null" type="checkbox" name="algo-2"
                        aria-labelledby="user-setting-control-2" disabled>
                      <span class="slider round"></span>
                    </label>
                    <div id="user-setting-control-2" class="label"> {{profileConfig?.preferences === 1?'Si':'No'}}</div>
                  </div>
                </div>
                <a role="button"  class="font-size-13 font-weight-bold" (click)="sendActionFormUpdate('preferences')">Editar intereses</a>
              </div>
            </div>
          </div>
          <div class="setting">
            <h5 class="setting-title">Perfil completo para postular</h5>
            <div class="setting-ctn">
              <div class="setting-section">
                <div class="alert-icon-text d-flex">
                  <div class="inner-section">
                    <i class="pj-ico pj-ico-info text-primary"></i>
                  </div>
                  <div class="inner-section">
                    <p class="no-mgn">Para postular <strong>debes haber completado tu perfil</strong></p>
                  </div>
                </div>
              </div>

              <div class="setting-section setting-section-control">
                <div>
                  <div class="switch-label" data-toggle="popover" data-placement="top" data-trigger="focus"
                    data-html="true"
                    data-content="Edita y completa tu perfil desde la opción &#34;Edición de perfil&#34;" tabindex="0">
                    <label class="switch">
                      <input [attr.checked]="profileConfig?.profileValid === 1 ? '' : null" type="checkbox"
                        name="algo-2" aria-labelledby="user-setting-control-2" disabled>
                      <span class="slider round"></span>
                    </label>
                    <div id="user-setting-control-2" class="label"> {{profileConfig?.profileValid===1?'Si':'No'}}</div>
                  </div>
                </div>
                <a role="button" class="font-size-13 font-weight-bold" (click)="sendActionFormUpdate('');">Editar
                  perfil</a>
              </div>
            </div>
          </div>
          <div class="setting">
            <h5 class="setting-title">Video clase demo</h5>
            <div class="setting-ctn">
              <div class="setting-section">
                <div class="alert-icon-text d-flex">
                  <div class="inner-section">
                    <i class="pj-ico pj-ico-info text-primary"></i>
                  </div>
                  <div class="inner-section">
                    <p class="no-mgn">Los candidatos que cargan una clase demo <strong>tienen más opciones de
                        ser reclutados</strong></p>
                  </div>
                </div>
              </div>
              <div class="setting-section setting-section-control">
                <div>
                  <div class="switch-label" data-toggle="popover" data-placement="top" data-trigger="focus"
                    data-html="true"
                    data-content="Edita o sube tu video desde la opción &#34;Agregar/Editar Video Demo&#34;"
                    tabindex="0">
                    <label class="switch">
                      <input type="checkbox" name="algo-5" aria-labelledby="user-setting-control-5"
                        [attr.checked]="profileConfig?.video === 1? '' : null" disabled>
                      <span class="slider round"></span>
                    </label>
                    <div id="user-setting-control-5" class="label">{{profileConfig?.video === 1?'Si':'No'}}</div>
                  </div>
                </div>
                <a role="button" class="font-size-13 font-weight-bold" (click)="sendActionFormUpdate('videoLink');">{{employeeVideo === 1?'Editar':'Agregar'}} Video Demo</a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-primary" (click)="saveEmployeePreference()">Guardar</button>
        </div>
      </form>
    </div>
  </div>
</li>